/**
 * Box 9 of the ICS-201: the incident organisation as a chart.
 *
 * The chart itself is shared with box 4 of the ICS-207; what belongs to this
 * box is the wording of its empty state and the way back to the roster.
 */

import React from 'react';
import { Link } from 'react-router';

import { Button } from '@/components/ui/button';
import { useActualIncidentId } from 'components/IAP/hooks/commonHooks';

import RosterOrgChartBox from '../RosterOrgChartBox';

export const Ics201OrgChartBox: React.FC = () => {
  const incidentId = useActualIncidentId();

  return (
    <RosterOrgChartBox
      emptyMessage="No one is on the roster yet. Seats filled on the Incident Roster appear here and print in Box 9."
      footer={
        <div className="tw:flex tw:justify-end">
          <Button
            variant="outline"
            size="sm"
            data-testid="ics201-edit-in-roster"
            render={<Link to={`/iap/${incidentId}/roster`} />}
          >
            Edit in Roster
          </Button>
        </div>
      }
    />
  );
};

export default Ics201OrgChartBox;
